var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,16.59V8l-.29-.71-4-4L14,3H10l-.71.29-4,4L5,8v8.59l-1.71,1.7L4,20H20l.71-1.71ZM6.41,18l.3-.29L7,17V8.41L10.41,5h3.18L17,8.41V17l.29.71.3.29Zm6.88,3.29,1.42,1.42-1,1L13,24H11l-.71-.29-1-1,1.42-1.42.7.71h1.18ZM14,2H10V1l1-1h2l1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifications);
export default __webpack_public_path__ + "static/1768397567/media/icon-notifications.5caa1f8202531920f0b8df73ce616b17.svg";
export { ForwardRef as ReactComponent };